export const urlSplitList = (downloadUrl) => {
  let urlList = downloadUrl?.split(/\,|\，/);
  urlList = urlList.map((item) => {
    item = item?.trim();
    return item;
  }).filter((item) => item);
  return urlList;
};
export const batchDownloadOperation = (DownLoadUrlList, handelCancel) => {
  let promiseAll = [];
  let aLinkList = [];
  DownLoadUrlList?.forEach((item, index) => {
    promiseAll[index] = new Promise((resolve, reject) => {
      aLinkList[index] = document.createElement("iframe");
      aLinkList[index].src = item;
      aLinkList[index].style.height = "0px";
      aLinkList[index].style.display = "none";
      document.body.appendChild(aLinkList[index]);
      resolve(aLinkList[index]);
    });
  });
  Promise.all(promiseAll).then((res) => {
    if (handelCancel) {
      handelCancel();
    }
    let timer = setTimeout(() => {
      res.forEach((item) => {
        item.remove();
      });
      clearTimeout(timer);
    }, 6e4);
  });
};
